module.exports = __webpack_public_path__ + "img/ico-maintenance.83cd13af.svg";